import React, { useState } from "react";
import { Typography, List, ListItem, ListItemText, Paper } from "@mui/material";
import OrderHistory from "../components/Orderhistory";
import AccountDetails from "../components/AccountDetails";
import ManageBuyers from "../components/ManageBuyers";
import SavedAddresses from "../components/SavedAddresses";
import SalesUseForm from "../components/SalesUseForm";

const AccountPage = () => {
  const [selectedTab, setSelectedTab] = useState("Order History");

  // Mapping tab names to components
  const renderContent = () => {
    switch (selectedTab) {
      case "Order History":
        return <OrderHistory />;
      case "My Account Details":
        return <AccountDetails />;
      case "Manage Buyers":
        return <ManageBuyers />;
      case "Saved Addresses":
        return <SavedAddresses />;
      case "Sales & Use Form":
        return <SalesUseForm />;
      default:
        return <OrderHistory />;
    }
  };

  return (
    <div style={{ display: "flex", padding: "20px" }}>
      {/* Sidebar */}
      <div
        style={{
          width: "250px",
          borderRight: "1px solid #ddd",
          paddingRight: "20px",
        }}
      >
        <Typography variant="h6" gutterBottom>
          My Account
        </Typography>
        <List>
          {[
            "Order History",
            "My Account Details",
            "Manage Buyers",
            "Saved Addresses",
            "Sales & Use Form",
          ].map((text) => (
            <ListItem
              key={text}
              button
              selected={selectedTab === text}
              onClick={() => setSelectedTab(text)}
              sx={{ cursor: "pointer" }}
            >
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
      </div>

      {/* Content Area */}
      <div style={{ flex: 1, paddingLeft: "20px" }}>
        <Paper style={{ padding: "20px", boxShadow: "none" }}>
          {renderContent()}
        </Paper>
      </div>
    </div>
  );
};

export default AccountPage;
